/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

var currentTags = [];

$(document).ready(function () {
    componentCustom.init();
});

window.loadMoreHideClassName = "load-more-hidden";
window.filterHideClassName = "d-none";
window.sortingButtons = $('#collection-sort-popover button.Popover__Value');
var componentCustom = {
    init: function () {
        this.initLoadMore();
        this.initLoadMoreButton();
        this.initSortLoadItems();
        if ($("#collection-filter-drawer").length > 0) {
            this.initApplyTags();
            this.initResetTags();
            this.initCurrentTagsToggle();
            this.initRangeSlider();
        }
    },

    scrollToHeaderSection: function () {
        $([document.documentElement, document.body]).animate(
            {
                scrollTop:
                    $(".PageHeader .collection-header").offset().top -
                    $(".Header__Wrapper").outerHeight() -
                    20,
            },
            1000
        );
    },

    initSortLoadItems: function () {
        window.sortingButtons.on('click', function(){
            setTimeout(function(){
                componentCustom.initResetTags();
                componentCustom.initLoadMore();
                componentCustom.initLoadMoreButton();
            }, 2500);
        });
    },

    initDisableLoadMore: function() {
        const allIProductGridItems = $(".ProductList > div");
        const loadMoreButton = $(".ProductListLoadMore");
        if (allIProductGridItems) {
            allIProductGridItems.removeClass(window.loadMoreHideClassName);
        }
        if (loadMoreButton) {
            loadMoreButton.addClass(window.loadMoreHideClassName);
        }
    },

    initLoadMore: function () {
        const initItemCountShow = 24;
        const allIProductGridItems = $(".ProductList > div");
        if (allIProductGridItems) {
            let itemsLoaded = 0;
            $(allIProductGridItems).each(function () {
                if (itemsLoaded < initItemCountShow) {
                    if ($(this).hasClass(window.loadMoreHideClassName) && !$(this).hasClass(window.filterHideClassName)) {
                        $(this).removeClass(window.loadMoreHideClassName);
                        itemsLoaded++;
                    }
                }
            });
        }
    },

    initLoadMoreButton: function () {
        const loadMoreAmount = 24;
        const allIProductGridItems = $(".ProductList > div");
        const loadMoreButton = $(".ProductListLoadMore");
        if (loadMoreButton && allIProductGridItems) {
            if (allIProductGridItems.length < loadMoreAmount) {
                loadMoreButton.addClass(window.loadMoreHideClassName);
            } else {
                loadMoreButton.removeClass(window.loadMoreHideClassName);
                loadMoreButton.on("click", function () {
                    window.productLoadMoreIndexer = 0;
                    allIProductGridItems.each(function () {
                        if (window.productLoadMoreIndexer < loadMoreAmount) {
                            if (
                                $(this).hasClass(window.loadMoreHideClassName)
                            ) {
                                $(this).removeClass(
                                    window.loadMoreHideClassName
                                );
                                window.productLoadMoreIndexer++;
                            }
                        }
                    });
                    if (window.productLoadMoreIndexer === loadMoreAmount) {
                        window.productLoadMoreIndexer = 0;
                    } else {
                        $(this).remove();
                    }
                });
            }
        }
    },

    initApplyTags: function () {
        $("#filter-apply-tags-custom").on("click", function () {
            $(".ProductList")
                .find(".Grid__Cell")
                .each(function () {
                    $(this).removeClass("d-none");
                });
            componentCustom.initDisableLoadMore();
            componentCustom.scrollToHeaderSection();

            $(".ProductList")
                .find(".Grid__Cell")
                .each(function () {
                    let productTags = $(this)
                        .find(".ProductItem")[0]
                        .dataset.tags.split(",");
                    for (index in productTags) {
                        var tag = productTags[index];
                        if (tag.indexOf("breite") >= 0) {
                            let value = tag.split("_")[1];
                            if (
                                value <
                                    $("#width-range-slider").slider(
                                        "values",
                                        0
                                    ) ||
                                value >
                                    $("#width-range-slider").slider("values", 1)
                            ) {
                                if ($(this)[0].className.indexOf("d-none") < 0)
                                    $(this).addClass("d-none");
                            }
                        } else if (tag.indexOf("lange") >= 0) {
                            let value = tag.split("_")[1];
                            if (
                                value <
                                    $("#length-range-slider").slider(
                                        "values",
                                        0
                                    ) ||
                                value >
                                    $("#length-range-slider").slider(
                                        "values",
                                        1
                                    )
                            ) {
                                if ($(this)[0].className.indexOf("d-none") < 0)
                                    $(this).addClass("d-none");
                            }
                        }
                    }
                });

            for (key in currentTags) {
                $(".ProductList")
                    .find(".Grid__Cell")
                    .each(function () {
                        let productTags =
                            $(this).find(".ProductItem")[0].dataset.tags;

                        if (
                            productTags.indexOf(
                                "" + key + "_" + currentTags[key]
                            ) < 0 &&
                            $(this)[0].className.indexOf("d-none") < 0
                        ) {
                            $(this).addClass("d-none");
                        }
                    });
            }

            if (
                $(".ProductList").find(".Grid__Cell:not(.d-none)").length <= 0
            ) {
                $("#no_result_reset").removeClass("d-none");
            } else {
                if ($("#no_result_reset")[0].className.indexOf("d-none") < 0) {
                    $("#no_result_reset").addClass("d-none");
                }
            }
        });
    },

    initResetTags: function () {
        $("#filter-reset-tags-custom_on-page").on("click", function () {
            componentCustom.initLoadMore();
            componentCustom.initLoadMoreButton();
            componentCustom.scrollToHeaderSection();
            currentTags = [];
            $(".Drawer__Content")
                .find(".Linklist__Item")
                .each(function () {
                    $(this).removeClass("is-selected");
                    $(this).find("button").removeClass("is-active");
                });

            $(".ProductList")
                .find(".Grid__Cell")
                .each(function () {
                    $(this).removeClass("d-none");
                });

            $("#length-range-slider").slider("values", 0, 0);
            $("#length-range-slider").slider("values", 1, 1000);

            $("#width-range-slider").slider("values", 0, 0);
            $("#width-range-slider").slider("values", 1, 1000);

            if (
                $("#filter-reset-tags-custom")[0].className.indexOf("d-none") <
                0
            ) {
                $("#filter-reset-tags-custom").addClass("d-none");
            }

            $("#length-range-slider-input-min").val(
                parseInt($("#length-range-slider-input-min").attr("min"))
            );
            $("#length-range-slider-input-max").val(
                parseInt($("#length-range-slider-input-max").attr("max"))
            );
            $("#width-range-slider-input-min").val(
                parseInt($("#width-range-slider-input-min").attr("min"))
            );
            $("#width-range-slider-input-max").val(
                parseInt($("#width-range-slider-input-max").attr("max"))
            );

            if ($("#no_result_reset")[0].className.indexOf("d-none") < 0) {
                $("#no_result_reset").addClass("d-none");
            }
        });

        $("#filter-reset-tags-custom").on("click", function () {
            componentCustom.initLoadMore();
            componentCustom.initLoadMoreButton();
            componentCustom.scrollToHeaderSection();
            currentTags = [];
            $(".Drawer__Content")
                .find(".Linklist__Item")
                .each(function () {
                    $(this).removeClass("is-selected");
                    $(this).find("button").removeClass("is-active");
                });

            $(".ProductList")
                .find(".Grid__Cell")
                .each(function () {
                    $(this).removeClass("d-none");
                });

            $("#length-range-slider").slider("values", 0, 0);
            $("#length-range-slider").slider("values", 1, 1000);

            $("#width-range-slider").slider("values", 0, 0);
            $("#width-range-slider").slider("values", 1, 1000);

            if (
                $("#filter-reset-tags-custom")[0].className.indexOf("d-none") <
                0
            ) {
                $("#filter-reset-tags-custom").addClass("d-none");
            }

            $("#length-range-slider-input-min").val(
                parseInt($("#length-range-slider-input-min").attr("min"))
            );
            $("#length-range-slider-input-max").val(
                parseInt($("#length-range-slider-input-max").attr("max"))
            );
            $("#width-range-slider-input-min").val(
                parseInt($("#width-range-slider-input-min").attr("min"))
            );
            $("#width-range-slider-input-max").val(
                parseInt($("#width-range-slider-input-max").attr("max"))
            );

            if ($("#no_result_reset")[0].className.indexOf("d-none") < 0) {
                $("#no_result_reset").addClass("d-none");
            }
        });
    },

    initCurrentTagsToggle: function () {
        $(".Drawer__Content")
            .find(".Linklist__Item")
            .each(function () {
                $(this)
                    .find("button")
                    .on("click", function () {
                        let key = $(this)[0].dataset.tag.split("_")[0];
                        let value = $(this)[0].dataset.tag.split("_")[1];

                        if ($(this)[0].className.indexOf("is-active") < 0) {
                            $(".Drawer__Content")
                                .find(".Linklist__Item")
                                .each(function () {
                                    if (
                                        $(this).find("button")[0] != null &&
                                        $(this).find("button")[0].dataset !=
                                            null &&
                                        $(this)
                                            .find("button")[0]
                                            .dataset.tag.indexOf(key) >= 0
                                    ) {
                                        $(this).removeClass("is-selected");
                                        $(this)
                                            .find("button")
                                            .removeClass("is-active");
                                    }
                                });

                            $(this)
                                .closest(".Linklist__Item")
                                .addClass("is-selected");
                            $(this).addClass("is-active");
                        } else {
                            $(this)
                                .closest(".Linklist__Item")
                                .removeClass("is-selected");
                            $(this).removeClass("is-active");
                        }

                        if (currentTags[key] == value) {
                            delete currentTags[key];
                        } else {
                            currentTags[key] = value;
                        }

                        if (
                            $("#filter-reset-tags-custom")[0].className.indexOf(
                                "d-none"
                            ) >= 0
                        ) {
                            $("#filter-reset-tags-custom").removeClass(
                                "d-none"
                            );
                        }
                    });
            });
    },

    initRangeSlider: function () {
        $("#length-range-slider").slider({
            range: true,
            min: 0,
            max: 1000,
            step: 10,
            values: [0, 1000],
            slide: function (event, ui) {
                if (
                    $("#filter-reset-tags-custom")[0].className.indexOf(
                        "d-none"
                    ) >= 0
                ) {
                    $("#filter-reset-tags-custom").removeClass("d-none");
                }

                $("#length-range-slider-input-min").val(ui.values[0]);
                $("#length-range-slider-input-max").val(ui.values[1]);

                $("#length-range-slider-input-min").attr("min", 0);
                $("#length-range-slider-input-min").attr("max", ui.values[1]);

                $("#length-range-slider-input-max").attr("min", ui.values[0]);
                $("#length-range-slider-input-max").attr("max", 1000);
            },
            create: function () {
                $("#length-range-slider-input-min").change(function () {
                    if (
                        $(this).val() >
                        $("#length-range-slider").slider("values", 1)
                    ) {
                        $(this).val(
                            $("#length-range-slider").slider("values", 1) - 10
                        );
                    }
                    if (
                        $(this).val() <
                        $("#length-range-slider").slider("option", "min")
                    ) {
                        $(this).val(
                            $("#length-range-slider").slider("values", 0)
                        );
                    }
                    $("#length-range-slider").slider("values", [
                        $(this).val(),
                        $("#length-range-slider").slider("values", 1),
                    ]);
                });
                $("#length-range-slider-input-max").change(function () {
                    if (
                        $(this).val() >
                        $("#length-range-slider").slider("option", "max")
                    ) {
                        $(this).val(
                            $("#length-range-slider").slider("option", "max")
                        );
                    }
                    if (
                        $(this).val() <
                        $("#length-range-slider").slider("option", "min")
                    ) {
                        $(this).val(
                            $("#length-range-slider").slider("values", 0) + 10
                        );
                    }
                    $("#length-range-slider").slider("values", [
                        $("#length-range-slider").slider("values", 0),
                        $(this).val(),
                    ]);
                });
            },
        });

        $("#width-range-slider").slider({
            range: true,
            min: 0,
            max: 1000,
            step: 10,
            values: [0, 1000],
            slide: function (event, ui) {
                if (
                    $("#filter-reset-tags-custom")[0].className.indexOf(
                        "d-none"
                    ) >= 0
                ) {
                    $("#filter-reset-tags-custom").removeClass("d-none");
                }

                $("#width-range-slider-input-min").val(ui.values[0]);
                $("#width-range-slider-input-max").val(ui.values[1]);

                $("#width-range-slider-input-min").attr("min", 0);
                $("#width-range-slider-input-min").attr("max", ui.values[1]);

                $("#width-range-slider-input-max").attr("min", ui.values[0]);
                $("#width-range-slider-input-max").attr("max", 1000);
            },
            create: function () {
                $("#width-range-slider-input-min").change(function () {
                    if (
                        $(this).val() >
                        $("#width-range-slider").slider("values", 1)
                    ) {
                        $(this).val(
                            $("#width-range-slider").slider("values", 1) - 10
                        );
                    }
                    if (
                        $(this).val() <
                        $("#width-range-slider").slider("option", "min")
                    ) {
                        $(this).val(
                            $("#width-range-slider").slider("values", 0)
                        );
                    }
                    $("#width-range-slider").slider("values", [
                        $(this).val(),
                        $("#width-range-slider").slider("values", 1),
                    ]);
                });
                $("#width-range-slider-input-max").change(function () {
                    if (
                        $(this).val() >
                        $("#width-range-slider").slider("option", "max")
                    ) {
                        $(this).val(
                            $("#width-range-slider").slider("option", "max")
                        );
                    }
                    if (
                        $(this).val() <
                        $("#width-range-slider").slider("option", "min")
                    ) {
                        $(this).val(
                            $("#width-range-slider").slider("values", 0) + 10
                        );
                    }
                    $("#width-range-slider").slider("values", [
                        $("#width-range-slider").slider("values", 0),
                        $(this).val(),
                    ]);
                });
            },
        });
    },
};
